exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "section.Intro {\n  -ms-flex-pack: end !important;\n      justify-content: flex-end !important;\n  opacity: 0;\n  -webkit-transition: opacity 0.25s;\n  -o-transition: opacity 0.25s;\n  transition: opacity 0.25s; }\n  section.Intro.Show {\n    opacity: 1; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Sections/Intro/SectionIntro.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/Sections/Intro/SectionIntro.css
// module chunks = 0